import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";
import { headersTokenExcel } from "../config/HeaderTokenExcel";

class RekapDeduction {
  list(page, limit, search, startDate, endDate, sort_by, sort_type) {
    const params = {
      start_date: startDate,
      end_date: endDate,
      page: page,
      limit: limit,
    };

    if (sort_by) {
      params.sort_by = sort_by;
    }

    if (sort_type) {
      params.sort_type = sort_type;
    }

    if (search) {
      params.search = search;
    }

    const endPoint = `/worker/salary/deduction/review?` + new URLSearchParams(params).toString();
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }

  post(payload) {
    const url = process.env.REACT_APP_API_URL_V2 + `/worker/salary/deduction/review/posting`;
    return axios.post(url, payload, headersTokenConfig);
  }

  excel(startDate, endDate) {
    const endPoint = `/rekap/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  excelRefund(startDate, endDate) {
    const endPoint = `/rekap/excel-refund?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenExcel);
  }
}

export default new RekapDeduction();
